import { ButtonTriggerEvent } from '../../../common/components';

export class ShowCategoryLinkModalActions {
  confirm: (event: ButtonTriggerEvent) => void;
  cancel?: () => void;
}

export class CategoryLinkModalData {
  constructor(link, jsonApi) {
    this.link = link;
    this.jsonApi = jsonApi;
  }
  link: string;
  jsonApi: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.category.link.modal/show.category.link.modal.provider.ts